export const useSite = () => {
  const {
    public: { siteRegion }, // siteRegion 代表 site
  } = useRuntimeConfig()
  const isZa = computed(() => {
    return siteRegion === 'za'
  })
  const isEu = computed(() => {
    return siteRegion === 'eu'
  })
  const isSosoValue = computed(() => {
    return siteRegion === 'sosovalue'
  })
  return { isZa, isEu, isSosoValue }
}
